export default "__VITE_ASSET__c2d9e4a1__"